import PropTypes from 'prop-types';

const proptypes = {
  setPartnerMemberNumber: PropTypes.func,
  submitFailed: PropTypes.bool,
};

export default proptypes;
